import { clsx } from 'clsx';

import { Icon, type IconProps } from '@repo/ui/Icon';

import s from './ToastRecipeContent.module.css';

type RecipeToastContent = {
  message: string;
  icon: IconProps['name'];
};

export const ToastRecipeContent = ({ message, icon }: RecipeToastContent) => {
  const iconClassName = clsx(
    icon === 'warning' && s.error,
    icon === 'check' && s.success,
  );

  return (
    <>
      <Icon name={icon} size="lg" className={iconClassName} />
      {message}
    </>
  );
};
